<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月23日 10:58:31
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div :class="[$route.name == 'login' ? 'login-head' : '', 'head']">
    <template v-if="$route.name == 'login' "></template>
    <template v-else>
      <div class="head-row">
        <div class="head-row-div">
          <el-image
            v-if="$route.meta.headIcon !== false"
            class="head-img head-img-right"
            @click="goBack"
            :src="headerImg"
          ></el-image>
          <span
            :class="[
              'head-title',
              $route.name == 'login' ? 'head-title-login' : '',
            ]"
            >{{ title }}</span
          >
        </div>
        <div class="head-row-div" v-if="!($route.name == 'password')">
          <span>
            <span class="login-user">登录人：</span>
            <span class="user-name">{{ user && user.UserName }}</span>
          </span>
          <!-- <el-image v-if="$route.meta.headIcon!==false" class="head-img head-img-left" @click="goHome" :src="require('@/assets/imgs/home.png')"></el-image> -->
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import headerImg from "@/assets/imgs/icon-daohang-fanhui-32@2x.png";
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      title: "",
      headerImg
    };
  },
  // 计算属性
  computed: {
    ...mapGetters(["user"]),
  },
  // 侦听器
  watch: {
    $route: {
      handler: function (val) {
        this.title = val.meta.title;
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },

  // 组件方法
  methods: {
    goBack() {
      console.log(this.$route.meta.goHome)
      if (this.$route.meta.goHome) {
        this.$router.push({
          name: "main",
        });
      }else{
        this.$router.go(-1);
      }

    },
    goHome() {
      this.$router.push({
        name: "main",
      });
    },
  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
   * 在实例初始化之后，组件属性计算之前，如data属性等
   */
  beforeCreate() {},
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {},
  /**
   * 在挂载开始之前被调用：相关的 render 函数首次被调用。
   */
  beforeMount() {},
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted() {},
  /**
   * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
   * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
   */
  beforeUpdate() {},
  /**
   * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
   * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
   */
  updated() {},
  /**
   * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
   */
  activated() {},
  /**
   * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
   */
  deactivated() {},
  /**
   * 实例销毁之前调用。在这一步，实例仍然完全可用。
   */
  beforeDestroy() {},
  /**
   * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
   * 所有的事件监听器会被移除，所有的子实例也会被销毁。
   */
  destroyed() {},
};
</script>

<style scoped>
.head {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 9998;
  display: flex;
  align-items: center;
  width:100%;
  height: 44px;
  box-sizing: border-box;
  padding: 0px 15px;
  background: linear-gradient(180deg, #029fd1 0%, #029fd1 100%);
  color: #fff;
  text-align: center;
}
.login-head {
  background: #fff;
}
.head-img {
  height: 16px;
  width: 16px;
}
.head-img-left {
  margin-left: 5px;
}
.head-img-right {
  margin-right: 5px;
}
.head-title {
  font-size: 18px;
  font-weight: 500;
  flex: 1;
  font-family: "PingFang SC Medium";
}
.head-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.head-row-div {
  display: flex;
  align-items: center;
}
.login-user {
  font-size: 12px;
  color: #92e5ff;
}
.user-name {
  font-size: 13px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/common/my-head.vue